import { AggregationType } from 'app/components/favourite-layout/favourite/common/favourite-interfaces';

/**
 * List of Aggregation Types that can be totalized
 */
export const CountableAggregationTypes = [
  AggregationType.Count,
  AggregationType.Total,
  AggregationType.Minimum,
  AggregationType.Maximum,
  AggregationType.DaysSinceLast,
  AggregationType.DaysSinceFirst
];

export const textMappings = {
  minimum: 'MinText',
  maximum: 'MaxText',
  total: 'TotalText',
  noExposureValue: 'NoExposureValue',
  noTargetValue: 'NoTargetValue'
};

export const configMappings = {
  suppressRepeatingRows: 'SuppressRepeatingRows',
  compactView: 'CompactView',
  hideAggrColumns: 'HideAggrColumns',
  hideHeader: 'HideHeader',
  hideTotals: 'HideTotals',
  wideLayout: 'WideLayout'
};

export const tooltipSection = 'tootltip';
